import $ from "jquery";
import ajax from "ajax";
import login from "login";
import template from "template";
import c from "common";
import dropdown from "dropdown";
import programlist from "ohjelmaopas/programlist";
import translate from "translate";
import recordings from "recordings";
import folder from "create-folder";
import "routing";
import ga from "analytics";
import "search";
import wildcard from "ohjelmaopas/wildcard";
import "awesomplete";
import Bacon from "Bacon.plugins";

var $body = $(document.body);
var lastSearchedWildCard = '';
var initialized = false;

function makeRecording(object) {
  var $currentTarget = c.$currentTarget(object.event);
  var folderId = object.folderId;
  var useWildcard = $("#createWildcard").is(":checked");
  var $wildcardName = $("#wildcardName");
  var $wildcardDays = $("#recordToDays");
  var data = {};
  var trackingData = {};

  function getEventType() {
    return object.method === "DELETE" ? "delete" : useWildcard ? "wildcard" : $currentTarget.hasClass('quick-rec') || $currentTarget.hasClass('haku-qrec') ? "quick" : "single";
  }

  if (login.isLoggedIn()) {
    if (useWildcard) {
      data.wildcard = $wildcardName.val();
      data.days = $wildcardDays.val().join();
      data.programId = $("#record-button").attr('data-program-id');
      data.channelId = $wildcardName.attr('data-channelid');
    } else {
      data.programId = $currentTarget.attr('data-program-id');
    }
    data.folderId = folderId ? folderId : 0;

    recordings.makeRecordings(data, object, useWildcard)
      .flatMap(updateProgramRecordingIndicator, data.programId)
      .doAction(recordings.updateProgram, data)
      .onValue(function () {
        var eventType = getEventType();
        trackingData = eventType === "wildcard" ? {
            rule: data.wildcard,
            channelId: data.channelId,
            folderId: data.folderId,
            days: data.days
          } : data;
        ga.trackRecording(eventType, trackingData);
      });
  }
}

function updateProgramRecordingIndicator(programId, recordingResult) {
  return programlist.getProgramById(programId).flatMap(updateSingleProgramRecording, recordingResult);
}

function updateSingleProgramRecording(recordingResult, programList) {
  if (programList.length === 1) {
    programList[0].recording = recordingResult;
  }
  return programList;
}

function setObjectFolderId(object) {
  object.folderId = $("#recordToFolder").val();
  return object;
}

function mapMethod(method, event) {
  return {
    method: method,
    event: event,
    folderId: 0
  };
}

function openTooltip(event, content, qTipEvents) {
  var $target = $(event.target);
  $target.qtip({
    overwrite: false,
    content: {
      text: content
    },
    position: {
      my: 'left center',
      at: 'right center',
      viewport: $(window)
    },
    events: qTipEvents,
    show: {
      event: event.type,
      ready: true
    }
  }, event);
}

function wildcardHelp(event) {
  openTooltip(event, $(event.target).parent().siblings(".wildcard-help"), {});
}

function wildcardResults(event) {
  openTooltip(event, $(event.target).siblings(".wildcard-results-hover"), {});
}

function toggleWildcardInput(value) {
  var $wildcard = $(".wildcard-input-container");
  initSuggestionsAutocomplete($wildcard, "#wildcardName");
  $wildcard.toggle(value);
  $wildcard.find("input").focus();
}

function filterOnlyWhenOneSuggestionExists($dropdown, text, input) {
  var $newFolderDiv = $dropdown.find("datalist");
  var onlyOneSuggestionExists = $newFolderDiv.find("option").length === 1;
  return onlyOneSuggestionExists && input.length > 0 ? !window.Awesomplete.FILTER_STARTSWITH(text, input) : true; // eslint-disable-line new-cap
}

function createUnhilightedListItem(text) {
  return window.Awesomplete.ITEM(text, ''); // eslint-disable-line new-cap
}

function initSuggestionsAutocomplete($dropdown, inputId) {
  var autocompletionOptions = {
    minChars: 0,
    filter: filterOnlyWhenOneSuggestionExists.bind(null, $dropdown),
    item: createUnhilightedListItem
  };

  var inputSelector = "input" + inputId + ".autocomplete";
  var awesompleteInput = document.querySelector(inputSelector);
  if (awesompleteInput) {
    var awesomplete = new window.Awesomplete(awesompleteInput, autocompletionOptions);
    $body.on('focus', inputSelector, function () {
      awesomplete.evaluate();
    });
  }
}

function toggleAddNewFolder($dropdown) {
  var $newFolderDiv = $dropdown.find(".new-folder"),
    $customSelect = $dropdown.find(".custom-dropdown-select");

  $(".record-partial, #recordings-toolbar").find(".toolbar-button.create-folder").toggle();
  if ($newFolderDiv.is(":visible")) {
    $newFolderDiv.hide();
    $(".ws-popover").removeClass("ws-po-visible");
    $customSelect.show();
  } else {
    $customSelect.hide();
    $newFolderDiv.show();
    initSuggestionsAutocomplete($dropdown, "#folderName");
    $newFolderDiv.find("input").focus();
  }
}

function wildcardActive(event) {
  return c.$target(event).is(":checked");
}

function getWildCardInput() {
  return $("#wildcardName");
}

function mapWildcardInfo($target) {
  var wildcardItem = $target.val().trim(),
    channelId = $target.attr("data-channelid");
  return [wildcardItem, channelId];
}

function updateWildcardMatches(matches) {
  var matchCount = matches ? matches.length : 0,
    resultText = translate("wildcard_matches", {
      count: matchCount
    });

  updateWildcardStatusText(resultText, matches);
  updateWildcardResultsPopup(matches);
}

function updateWildcardStatusText(resultText, error) {
  $(".wildcard-results").text(resultText).toggleClass("error", !error);
}

function updateWildcardResultsPopup(programs) {
  var $resultsHover = $(".wildcard-results-hover");
  if (!programs || programs.length === 0) {
    $resultsHover.html($(".wildcard-help").html());
    return;
  }
  var i, singleProgram;
  $resultsHover.html('');
  for (i in programs) {
    if (programs.hasOwnProperty(i)) {
      if (i >= 10) {
        $resultsHover.append(translate("wildcard_matches_andmore", {
          count: programs.length - i
        }));
        break;
      }

      singleProgram = programs[i];
      $resultsHover.append(singleProgram.name + " (" + singleProgram.channel.name + ") " + singleProgram.startTime);
      $resultsHover.append("<br/>");
    }
  }
}

function mapFolders(folders) {
  var acc = [];
  if (folders) {
    folderTraverse(folders, acc);
    acc.shift();
  }
  return acc;
}

function folderTraverse(item, acc) {
  acc.push(item);
  item.folders.forEach(function (childFolder) {
    folderTraverse(childFolder, acc);
  });
}

function getProgramAjaxStream(programId) {
  return ajax.stream({
    url: "/ohjelmaopas/api/schedule/program/" + programId,
    type: "GET",
    dataType: "json"
  });
}

function updateProgramLargeThumbnail(programId) {
  getProgramAjaxStream(programId).onValue(renderProgramLargeThumbnail);
}

function renderProgramLargeThumbnail(data) {
  template.get("ohjelma-thumbnail-partial")
    .combine(data.program, template.render)
    .lazyAssign($, '.ohjelma-content .image-column', "html");
}

function pageHasLargeThumbnail() {
  return $('.ohjelma-content .image-column').length === 1;
}

function updateRecOptions(programId) {
  if (typeof programId === "undefined") {
    return;
  }
  var htmlStream, programData = getProgramAjaxStream(programId),
    newRule = $(".record-section").attr("data-wildcard-rule"),
    recordable;

  htmlStream = Bacon.combineWith(function (jsonData, recordPartial, wildcardPartial) {
    jsonData.loggedIn = true;
    jsonData.folders = mapFolders(jsonData.folders);
    jsonData.newRuleName = newRule;
    recordable = jsonData.program.channel.recordable;
    return recordPartial.render(jsonData, {
      "record-partial": recordPartial,
      "record-active-wildcard-partial": wildcardPartial
    });
  }, programData, template.get("record-partial"), template.get("record-active-wildcard-partial"));
  htmlStream.lazyAssign($, ".record-partial", "html");
  htmlStream.onValue(function () {
    dropdown.init();
    $(".record-section").removeClass("disabled").find(".custom-dropdown").removeClass("disabled");
    $(".recordings-column").toggleClass("recordable", recordable);
    $("#record-button, #remove-record-button").focus();
  });
  programData.filter(pageHasLargeThumbnail).onValue(renderProgramLargeThumbnail);
}

function addNewFolderActive(visible) {
  return $(".new-folder input").is(":visible") === visible;
}

function createFolder(object) {
  return folder.createDeprecated({
    "folderName": $(".new-folder input").val(),
    "parentId": 0
  }, function (e) {
    recordings.openErrorTooltip(object.event, e);
  }).map(function (value) {
    object.folderId = value;
    return object;
  });
}

function checkWildCard(value) {
  var wildCardItem = value[0],
    valid;
  if (lastSearchedWildCard === wildCardItem) {
    valid = false;
  } else {
    valid = recordings.isWildcardValid(wildCardItem);
    toggleWildcardStatus(valid);
    lastSearchedWildCard = wildCardItem;
  }

  return valid;
}

function toggleWildcardStatus(wildcardValidity) {
  if (!wildcardValidity) {
    updateWildcardStatusText(translate("invalid_wildcard_rule"), wildcardValidity);
  }
  $("#record-button").attr("disabled", !wildcardValidity).toggleClass("disabled", !wildcardValidity).toggleClass("green", wildcardValidity);
}

function isEnterPressed(isPressed, e) {
  return e.keyCode === 13 === isPressed;
}

function activateClosingOfElement(event) {
  var target = event.target;
  var isMouseWithin18pxFromRightSideOfElement = target.offsetWidth - 18 < event.clientX - target.getBoundingClientRect().left;
  if (isMouseWithin18pxFromRightSideOfElement) {
    $(target).addClass("onX");
  } else {
    $(target).removeClass("onX");
  }
}

function quickRecStreamInit() {
  $body.asEventStream("click", ".quick-rec").doAction(c.stopEvent).map(mapMethod, 'PUT').onValue(makeRecording);
}

function getProgramDetails($target) {
  return [{
    programId: $target.attr('data-id'),
    name: $target.attr('data-description')
  }];
}

function deleteRecordings(programs) {
  return recordings.deleteRecordings(programs).map(function () {
    return programs;
  });
}

function updatePrograms(data) {
  data.forEach(function (program) {
    programlist.getProgramById(program.programId).onValue(recordings.updateProgram, data);
  });
}

function createDeleteRecordingsStream() {
  return $body.asEventStream("click", "#remove-finished-recording-button")
    .doAction(c.stopEvent)
    .map(c.$target)
    .map(getProgramDetails)
    .flatMap(recordings.confirmDelete)
    .flatMap(deleteRecordings);
}

function initDeleteRecordingAction() {
  createDeleteRecordingsStream().onValue(updatePrograms);
}

function trackFolderSuggestionSelection(clickEvent) {
  var folderName = clickEvent.target.value,
    $data = $("[data-programid]"),
    programId = $data.data("programid"),
    programName = $data.text().trim();
  ga.trackWithSection("select-folder-from-suggestions", "Selected folder suggestion '" + folderName + "' for " + programName + " (" + programId + ")");
}

function trackWildcardSuggestionSelection(clickEvent) {
  var wildcardName = clickEvent.target.value,
    $data = $("[data-programid]"),
    programId = $data.data("programid"),
    programName = $data.text().trim();
  ga.trackWithSection("select-wildcard-from-suggestions", "Selected wildcard suggestion '" + wildcardName + "' for " + programName + " (" + programId + ")");
}

function findInputField(event) {
  return $(event.currentTarget).find("input");
}

function disableButton(value, event) {
  $(event.currentTarget).toggleClass("disabled progress", value);
}

function init() {
  if (initialized) {
    return;
  }
  initialized = true;
  var recButton, recButtonCombined, recRemoveButton,
    newFolderAjaxStream, existingFolderStream, keyUpStream, wildCardSuggestionSelectedStream;
  recRemoveButton = $body.asEventStream("click", "#remove-record-button:not(.disabled)").doAction(c.stopEvent).doAction(disableButton, true).map(mapMethod, 'DELETE');

  recButton = $body.asEventStream("click", "#record-button:not(.disabled)").doAction(c.stopEvent).doAction(disableButton, true).map(mapMethod, 'PUT');
  newFolderAjaxStream = recButton.filter(addNewFolderActive, true).flatMap(createFolder);

  existingFolderStream = recButton.filter(addNewFolderActive, false).flatMap(setObjectFolderId);
  recButtonCombined = newFolderAjaxStream.merge(existingFolderStream);
  recButtonCombined.merge(recRemoveButton).onValue(makeRecording);

  var openWildcard = $body.asEventStream("change", "#createWildcard").doAction(c.stopEvent);
  openWildcard.onValue(toggleWildcardInput);
  openWildcard.filter(wildcardActive).map(getWildCardInput).map(mapWildcardInfo).filter(checkWildCard).flatMap(wildcard.findByRule).onValue(updateWildcardMatches);

  $body.asEventStream("click", ".wildcard-input-info").onValue(wildcardHelp);
  $body.asEventStream("click", ".wildcard-results").onValue(wildcardResults);

  keyUpStream = $body.asEventStream("keyup", "#wildcardName").debounce(500);
  keyUpStream.filter(isEnterPressed, true).map(mapMethod, 'PUT').onValue(makeRecording);

  $body.asEventStream("touchstart click", ".record-partial .toolbar-button.create-folder, #recordings-toolbar .toolbar-button.create-folder").doAction(c.stopEvent).map(dropdown.getSibling).doAction(dropdown.hideOptions).onValue(toggleAddNewFolder);

  $body.asEventStream("mousemove", ".closable").onValue(activateClosingOfElement);
  $body.asEventStream("touchstart click", ".closable.onX, .closable + .icon").map(dropdown.get).onValue(toggleAddNewFolder);

  $body.asEventStream("awesomplete-selectcomplete", ".new-folder").onValue(trackFolderSuggestionSelection);

  wildCardSuggestionSelectedStream = $body.asEventStream("awesomplete-selectcomplete", ".wildcard-input")
    .doAction(trackWildcardSuggestionSelection)
    .map(findInputField);

  keyUpStream.filter(isEnterPressed, false)
    .map(c.$target)
    .merge(wildCardSuggestionSelectedStream)
    .map(mapWildcardInfo)
    .filter(checkWildCard)
    .flatMap(wildcard.findByRule)
    .onValue(updateWildcardMatches);

}

export default {
  init: init,
  updatePrograms: updatePrograms,
  mapFolders: mapFolders,
  updatePartial: updateRecOptions,
  updateProgramLargeThumbnail: updateProgramLargeThumbnail,
  createDeleteRecordingsStream: createDeleteRecordingsStream,
  initDeleteRecordingAction: initDeleteRecordingAction,
  initQuickRecAction: quickRecStreamInit,
  toggleAddNewFolder: toggleAddNewFolder
};



// WEBPACK FOOTER //
// ./web/js/ohjelmaopas/recordings.js